// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.filter-redesign {
    font-family: Nunito;
    .sideNav-listBox:nth-last-child(1) {
      padding-bottom: 21px;
      margin-bottom: 0px;
    }
    .sideNav-subHeader {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
    }
    .navigation-main {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
      font-family: Nunito;
    }
    .category-item-li {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
    }
    .cat-showMore {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
      text-transform: capitalize;
    }
    .cat-showLess {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
      font-family: Nunito;
      text-transform: capitalize;
    }
    .filter-product-count {
      padding: 21px 0px;
    }
    .count-section {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
      font-weight: ${(props) => props.theme.typography.fontWeights.semibold};
      word-break: break-all;
      text-align: left;
    }
    .items-count-content-number {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
    }
    .itemsLabel {
      word-break: break-all;
    }
  }
`;
